import React, { useState, useEffect, useRef } from "react";

import iconBG from "../../../../../revampComponents/Atom/Icons/iconBG.svg";
import iconEdit from "../../../../../revampComponents/Atom/Icons/iconEdit.svg";
import iconDelete from "../../../../../revampComponents/Atom/Icons/iconDelete.svg";
import LoadingSpinner from "../../../../../revampComponents/Atom/Loading";
import ImageModal from "../../../../../revampComponents/ImageUploader/CropImageModal";
import customCardImage from "../../../../../assets/img/common/bg.svg";

import UploadImageButton from "../../../../../revampComponents/ImageUploader/uploadImageButton";
import RouteModal from "../../../../../revampComponents/Atom/Modals/RouteModal";
import TippyIcon from "../../../../../revampComponents/Atom/TippyIcon";
import { errorToaster } from "../../../../../reusable/common";
import FileUpload from "../../../../../revampComponents/Molecule/Inputs/FileUpload/FileUpload";

const EventLogo = ({ formik, isRestricted }) => {
	//UseState for edit image
	const [editImage, setEditImage] = useState(false);

	//For Image
	const [uploadedImage, setuploadedImage] = useState("");
	const [imageModal, setImageModal] = useState(false);
	const [imageRef, setImageRef] = useState("");
	const [imageInput, setImageInput] = useState("");
	const [previewLogoUrl, setPreviewLogoUrl] = useState("");
	const imageModuleNo = 12;
	const componentDidMount = useRef(false);

	useEffect(() => {
		//On edit poster image and organiser image should be shown in preview
		if (formik && formik.values && formik.values.navbar_icon) {
			setPreviewLogoUrl(formik.values.navbar_icon);
		}
	}, [formik.values]);

	const imageHandler = (imageUrl, previewUrl) => {
		formik.setFieldValue("navbar_icon", imageUrl);
		setPreviewLogoUrl(previewUrl);
	};

	// function to open image model
	const openImageModal = e => {
		if (e.target.files[0].size < 614400) {
			setImageRef(e.target);
			setImageModal(true);
			setuploadedImage(e.target);
			setImageInput(e.target.name);
			setEditImage(true);
		} else {
			errorToaster("Image size is greater than 600 KB. It should be less than 600KB.");
		}
	};

	// function to edit image model
	const EditImageModal = () => {
		setImageModal(true);
		setImageInput("navbar_icon");
		setImageRef(uploadedImage);
	};
	//function to close image model on click on cancel button
	const closeImageModal = () => {
		setImageRef("");
		setImageModal(false);
	};

	//function used to remove selected image
	const removeSelectedImage = () => {
		formik.setFieldValue("navbar_icon", "");
		setPreviewLogoUrl("");
	};

	return (
		<div className="justify-content-end text-right">
			<ImageModal
				show={imageModal}
				imageHandler={imageHandler}
				closeModal={closeImageModal}
				imageHandlerFunc={imageHandler}
				moduleNo={imageModuleNo}
				imageRef={imageRef}
				aspect={true}
			/>

			{!previewLogoUrl && (
				<div className="d-flex justify-content-end">
					<div className="justify-content-end px-3 pt-4 pb-2">
						<FileUpload
							onChange={imageHandler}
							moduleNumber={imageModuleNo}
							aspect={2 / 1}
						>
							<UploadImageButton
								shape="rectangle"
								size="250px"
								height="125px"
								id="navbar_icon"
								uploadText={`Add Logo`}
							/>
						</FileUpload>
					</div>
				</div>
			)}
			{formik.errors.navbar_icon && formik.touched.navbar_icon && (
				<p className="text-danger text-right" style={{ marginRight: "10%" }}>
					{formik.errors.navbar_icon}
				</p>
			)}
			{previewLogoUrl && (
				<div
					className={`${isRestricted ? "disable-restricted-elements " : ""}d-flex justify-content-end`}
				>
					<div className="customCard justify-content-end px-3 py-4">
						<div className="customCard-container" style={{ position: "relative" }}>
							<img
								className="uploadButton"
								alt="Crop"
								style={{
									// padding: "2px",
									maxWidth: "300px",
									maxHeight: "150px",
									width: "250px",
									height: "125px",
									// border: "2px solid #572148",
									borderRadius: "7px"
								}}
								src={previewLogoUrl}
							/>
							{editImage == true && (
								<span
									onClick={EditImageModal}
									style={{
										position: "absolute",
										top: "-3%",
										right: "-2%"
									}}
								>
									<TippyIcon content="Edit">
										<img
											style={{
												backgroundImage: `url(${iconBG})`,
												backgroundPosition: "center",
												backgroundSize: "cover",
												backgroundRepeat: "no-repeat",
												padding: "3.5px 3px",
												height: "23px",
												width: "23px",
												cursor: "pointer"
											}}
											src={iconEdit}
										/>
									</TippyIcon>
								</span>
							)}

							<span
								onClick={removeSelectedImage}
								style={
									editImage == false
										? {
												position: "absolute",
												bottom: "-3%",
												right: "-3%"
											}
										: {
												position: "absolute",
												bottom: "-3%",
												right: "-3%"
											}
								}
							>
								<TippyIcon content="Delete">
									<img
										style={{
											backgroundImage: `url(${iconBG})`,
											backgroundPosition: "center",
											backgroundSize: "cover",
											backgroundRepeat: "no-repeat",
											padding: "3.5px 3px",
											height: "22px",
											width: "22px",
											cursor: "pointer"
										}}
										src={iconDelete}
									/>
								</TippyIcon>
							</span>
						</div>
					</div>
				</div>
			)}

			<style jsx>{`
				.uploadButton:hover * {
					// opacity: 0.6;
				}

				.ReactCrop .ReactCrop__crop-selection {
					border-radius: 2px;
				}

				.uploadButton {
					box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
				}

				.uploadButton:hover {
					background-color: rgb(0 0 0 / 11%) !important;
				}
				.customCard-container {
					background-image: url(${customCardImage});
					background-size: cover;
					background-repeat: no-repeat;
				}
			`}</style>
		</div>
	);
};

export default EventLogo;
